/** Prefix used by address create optimistic updates (`useCreateAddress`). */
export const OPTIMISTIC_ADDRESS_ID_PREFIX = 'temp-'

export function isOptimisticAddressId(id: string): boolean {
  return id.startsWith(OPTIMISTIC_ADDRESS_ID_PREFIX)
}
